import texts from './texts.js';
import produkte from './produkte.js';
import mafos from './mafos.js';

Vue.config.devtools = true;
var gaInit = false;
var scrollStore = 0;
var dfApp = 0;

// Vue Components
Vue.component('waves', {
    props: {
        mirrored: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        waveClasses() {
            return {
                'waves': true,
                'mirrored': this.mirrored
            }
        }
    },
    template: '<div :class="waveClasses"></div>'
});

Vue.component('deco', {
    props: {
        type: {
            type: String,
            required: true
        }
    },
    computed: {
        decoClasses() {
            return ['deko', this.type]
        },
        decoStyle() {
            return {
                backgroundImage: `url(../images/deco/${this.type}.png)`
            }
        }
    },
    template: '<div :class="decoClasses" :style="decoStyle"></div>'
});

window.dataLayer = window.dataLayer || [];

window.mafoSlider = 0;

window.openCookiebot = function() {

    if(typeof Cookiebot !== 'undefined') {
        Cookiebot.show();
    }

}


function doneCallback(solution) {
}
/*******************************************/
/*******************************************/
/*******************************************/
/*******************************************/
/*******************************************/
/*******************************************/
/*******************************************/
/*******************************************/
/*******************************************/
/*
/*  Vue Instance
*/

var initVue = function() {

   dfApp = new Vue({

        el: "#app",
        delimiters: ['${', '}'],

        data: {

            lang: 'de',

            lockApi: false,
            apiTimer: 0,
            firstLoad: true,
            csrfexpired: false,
            cookieBotDone: false,

            customerInformations: {},
            
            dfCode: '',
            dfToken: '',
            dfEmail: '',
            dfFirstname: '',
            dfLastname: '',
            dfEmailSave: '',
            dfEmailAgain: '',
            dfCountry: '',
            dfNewsletter: false,
            dfTerms: false,
            haRecaptcha: false,
            dfRecaptcha: false,
            dfRecpatcha: false,
            won: 0,
            isWinner: false,
            barcode: '',
            voucherPdfRef: '',
            voucherLink: '',
            prize: false,
            prizeImg: '',
            prizeTitle: '',
            voucherPdfRef: '',
            externalIdentifier: '',

            noEmail: false, // Speichert ob Hauptverlosung oder nicht
            
            // UI
            
            apiPause: 2000,
            homeAnimation: false,
            gewinnShown: 0,
            showMoreIntro: false,
            showMoreInfos: false,
            showWhereCode: false,
            showSelect: false,
            dfVideo: false,
            consentMarketing: false,
            waitForApi: false,
            currentPage: "",
            mounted: false,
            preloaded: false,
            scrollTo: "",
            saveScrollPosition: 0,
            notificationTimer: 0,
            scrollingBack: 0,
            sliderReady: 0,
            hasFocus: '',
            friendlyFired: false,

            rwdMenu: false,

            codeError: '',
            submittingCodeForm: false,
            submittingForm: false,
            formProcessed: false,
            captcha: null,
            noRecaptcha: false,
            errorTracked: false,
            limitDay: false,
            throttleError: false,
            timeOutError: false,
            submitError: false,
            alreadyFulfilled: false,
            thankYou: false,

            dfOrder: 0,

            resultReceived: false,

            noRecaptcha: false,

            gewinnShown: 0,

            gewinnCurrent: {},

            prizeIdx: {
                WIN1: 1,
                WIN2: 2,
                WIN3: 3,
                WIN4: 3
            }, 
            prizeTitles: {
                1: '500&nbsp;€',
                2: '250&nbsp;€',
                3: '100&nbsp;€',
                4: '50&nbsp;€'
            },

            texts: texts,

            produkte: produkte,

            mafos: mafos,

            mafoLock: false,
            mafoDone: false,
            mafoAnswers: ['','','','','','']

        },

        methods: {

            initSelects: function() {

                df.initSelects();

            },

            initSwiper: function() {

                df.initSwiper();
            },

            initSlideshow: function() {

                df.initSlideshow();

            },

            initRest: function() {

                window.setTimeout(function() {
                    df.resizeTrigger();
                    this.lang = window.default_lang ?? 'de';
                    this.mounted = true;
                    jQuery("body").addClass("loaded");
                    jQuery("body #wrap").addClass("show");
                    df.initSelects();
                    var anchor = window.default_anchor ? '#'+window.default_anchor : self.location.hash;
                    if (anchor ) {
                        if(anchor.substring(1,3) != "st") {
                            this.sp(anchor.substring(1));
                            self.location.hash = "";
                        } else {
                            this.sp('home');
                            window.setTimeout(function() {
                                this.scrollTo = "#" + anchor.substring(3);
                                self.location.hash = "";
                            }.bind(this),800);                                
                        }
                    } else if(jQuery('meta[name="page"]').attr('content')) {
                        this.haCode = jQuery('meta[name="code"]').attr('content');
                        this.sp(jQuery('meta[name="page"]').attr('content'));
                    } else {
                        this.sp("home");
                    }
                    window.setTimeout(function() {
                        this.initSwiper();
                        this.initSlideshow();
                        this.activateRecaptcha();
                    }.bind(this), 860);
                    if(document.getElementById('form')) {
                        document.getElementById('form').addEventListener('keydown', function(event) {
                            if (event.keyCode === 13) {
                                event.preventDefault(); // Prevent the form from submitting
                                return false;
                            }
                        });
                    }
                }.bind(this),500);

                window.setTimeout(function() {
                    this.homeAnimation = true;
                }.bind(this),2400);

                document.addEventListener('click', function(e) {
                    const link = e.target.closest('a[href^="#"]');
                    if (link) {
                        const hash = link.getAttribute('href').substring(1);
                        if (hash) {
                            e.preventDefault();
                            this.sp(hash);
                        }
                    }
                }.bind(this));

                window.setTimeout(function() {
                    const myWidget = document.querySelector(".frc-captcha");
                    if(!myWidget) {
                        return;
                    }
                    console.log("Widget listener attached");
                    myWidget.addEventListener("frc:widget.statechange", function(event) {
                        console.log("Widget was completed! Response:", event.detail.response);
                    });
                    myWidget.addEventListener("frc:widget.error", function(event) {
                        console.log("Widget errored:", event.detail.response);
                    });
                    myWidget.addEventListener("frc:widget.expired", function(event) {
                        console.log("Widget expired:", event.detail.response);
                    });
                }.bind(this), 4000);

            },

            resetAll: function(goHome) {

                if(goHome===true) {
                    self.location.href = "/?lang="+this.language;
                    return true;
                }

                if(goHome) {
                    self.location.href = "/?lang="+this.language+"#"+goHome;
                    self.location.hash = goHome
                    window.setTimeout(function() {
                        window.location.reload();
                    },500);
                    return true;
                }

                this.resultReceived = false;
                this.customerInformation = {};
                this.dfCode = "XXXXXXXXXX";
                this.dfEmail = "";
                this.dfEmailSave = "";
                this.dfVorname = "";
                this.dfNachname = "";
                this.dfStreet = "";
                this.dfHouseNr = "";
                this.dfZip = "";
                this.dfCity = "";
                this.dfPhone = "";
                this.prize = 1;
                this.prizeImg = "1-version-headway-foyer";
                this.prizeTitle = "FF";
                this.barcode = "";
                this.voucherPdfRef = "";
                this.submittingCodeForm = "";
                this.submittingForm = "";
                this.formProcessed = false;
                this.noRecaptcha = false;
                this.dfNewsletter = false;
                this.throttleError = false;
                this.timeOutError = false;
                this.limitDay = false;
                this.submitError = false;
                this.alreadyFulfilled = false;
                this.showMoreInfos = false;
                this.friendlyFired = false;
                
                jQuery('input[type="text"]').val();
                
                if(jQuery("#recaptcha").html()!="") {
                    this.resetRecaptcha();
                }
                
                this.dfTerms = false;
                this.noEmail = false;

                jQuery('input[type="checkbox"]').prop("checked", false);

                if (goHome) {
                    this.showpage("home");
                    this.homeAnimation = false;
                    this.initSwiper();
                    window.setTimeout(function() {
                        this.homeAnimation = true;
                        this.scrollTo = "#df_code";
                    }.bind(this),200);
                }

            },

            // Language

            switchLang: function( lang ) {
                this.lang = this.lang=='de' ? 'fr' : 'de';
                document.documentElement.lang = this.lang;
                this.initAccordions();
            },

            langImage: function( src ) {
                return 'images/' + this.lang + '/' + src;
            },

            // Gewinne

            setShowMoreInfos: function( state ) {

                this.showMoreInfos = state;

                jQuery('body').removeClass("scrollLock");
                if(state) {
                    scrollStore = jQuery(window).scrollTop();
                    this.track('Gewinnkarusell',this.gewinne[this.gewinnShown].short);
                    jQuery('body').addClass("scrollLock");
                    jQuery('body').css("top","-"+scrollStore+"px");
                } else {
                    jQuery(window).scrollTop(scrollStore);
                    jQuery('body').css("top","0px");
                }

            },

            // UI

            scrollToForm: function() {
                this.scrollTo = "#enterName";
            },

            doShowMoreIntro: function( value ) {
                this.showMoreIntro = value;
            },

            initAccordions: function() {

                window.setTimeout(
                    function() {
                        const accordionHeaders = document.querySelectorAll("section.show .accordion h3.accordion");
                        accordionHeaders.forEach(header => {
                            if(!header.classList.contains("initialized")) {
                            header.addEventListener("click", function() {
                                if (this.classList.contains("open")) {
                                    accordionHeaders.forEach(h => {
                                        h.classList.remove("open");
                                        h.setAttribute("aria-expanded", "false");
                                    });
                                } else {
                                    var pauseForMs = 0;
                                    accordionHeaders.forEach(h => {
                                        pauseForMs = Math.max(pauseForMs, parseInt(h.nextElementSibling.style.transitionDuration) || 0);
                                        h.nextElementSibling.style.transitionDuration = Math.floor(pauseForMs/2)+"ms";
                                        h.classList.remove("open");
                                        h.setAttribute("aria-expanded", "false");
                                    });
                                    header.nextElementSibling.style.height = header.nextElementSibling.querySelector("div").scrollHeight + "px";
                                    this.classList.add("open");
                                    let numCharacters = header.nextElementSibling.querySelector("div").innerHTML.length;
                                    header.nextElementSibling.style.transitionDuration = (numCharacters*0.3)+"ms";
                                    window.setTimeout(function() {
                                        const rect = this.getBoundingClientRect();
                                        const inView = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
                                        if (!inView) {
                                            this.scrollIntoView({ behavior: "smooth", block: "start" });
                                        }
                                    }.bind(this),pauseForMs/2);
                                    this.setAttribute("aria-expanded", "true");
                                }
                            });
                            header.classList.add("initialized");
                            }
                        });
                    }, 500);

                    
            },    


            setShowWhereCode: function( state ) {

                this.showWhereCode = state;
                jQuery('body').removeClass("scrollLock");
                if(state) {
                    scrollStore = jQuery(window).scrollTop();
                    jQuery('body').addClass("scrollLock");
                    jQuery('body').css("top","-"+scrollStore+"px");
                    window.setTimeout(function() {
                        jQuery('#whereCodeVideo').get(0).currentTime = 0;                        
                        jQuery('#whereCodeVideo').addClass("show");
                        jQuery('#whereCodeVideo').get(0).play();
                    }, 246);
                } else {
                    jQuery('#whereCodeVideo').removeClass("show");
                    jQuery(window).scrollTop(scrollStore);
                    jQuery('body').css("top","0px");
                }
            },


            goHome: function() {

                if (this.currentPage != "danke") {
                    this.sp("home");
                    window.setTimeout(function() {
                        this.scrollTo = "#app";
                    }.bind(this),500);
                } else {
                    this.resetAll(true);
                }

            },

            goTnb: function() {

                this.sp('tnb');

            },

            goData: function() {

                this.sp('data');

            },

            scrollToTop: function() {

                this.scrollTo = "header";

            },

            // Utilites

            datum: function(d) {

                date = new Date(Date.parse(d.split("-").join("/")));

                return date.toLocaleDateString();

            },

            uc: function() {

                alert("Noch nicht implementiert");

            },

            sp: function(id,newHistory) {

                if(!dfApp) {
                    return false;
                }

                if (this.currentPage != id) {
                    this.showpage(id,newHistory);
                    this.currentPage = id;
                }

            },

            goBack: function() {

                history.back();

            },

            track: function(category, action, label) {

                df.track(category, action, label);
            
            },

            refreshCookieBot: function() {

                jQuery("#CookieDeclarationChangeConsentChange").off("click").on("click",function(e) {
                    Cookiebot.show();
                    e.preventDefault();
                })
                jQuery("#CookieDeclarationChangeConsentWithdraw").off("click").on("click",function(e) {
                    Cookiebot.withdraw();
                    e.preventDefault();
                })

            },

            showpage: function(id, newHistory) {

                if(!dfApp) {
                    return false;
                }

                newHistory = (newHistory === undefined) ? true : newHistory;

                let st = jQuery(window).scrollTop();
                df.scrollMemory[this.currentPage] = jQuery(window).scrollTop();

                if(id == "qr") {
                    id = "home";
                    this.track("pageview","qr");
                    self.location.hash = "";
                }

                if (id !== "") {
                    if(jQuery("section#df_" + id).length==0) {
                        id = "home";
                    }
                    if (newHistory && id!=this.currentPage) {
                        if(id!="init") {
                            this.track("pageview",id);
                        } else {
                            id = "home";
                        }
                        history.pushState({
                                page: id
                            },
                            null,
                            self.location.href
                        );
                    }
                    this.currentPage = id;
                }

                this.currentPage = id;

                let scrollT = df.scrollMemory[id];

                jQuery("body").attr("data-page", id);

                jQuery("#app section").removeClass("show");
                jQuery("#app section#df_" + id).addClass("show");
                jQuery(".dfText .show").removeClass("show");
                jQuery('html,body').scrollTop(0);
                
                this.restTheApi();
                df.initSelects();
                df.resizeTrigger();
                this.refreshCookieBot();
                
                window.setTimeout( function() {
                    this.initAccordions();
                    this.resetRecaptcha();
                    jQuery("#app").addClass("show");
                }.bind(this), 200 );
                
            },

            newConfetti: function() {
                var i = 0;
                var confettiAmount = 86;
                var confettiPieces = 76;
                var width = window.innerWidth;
                document.querySelectorAll('.confetti').forEach(function(confetti) {
                    confetti.remove();
                });
                for(i = 0; i < confettiAmount; i++) {
                    var confetti = document.createElement('div');
                    var confettiImg = document.createElement('img');
                    confetti.appendChild(confettiImg);
                    confetti.className = 'confetti';
                    var depth = Math.random();
                    if(Math.random()>0.5) {
                        confetti.classList.add('clockWise');
                    }
                    confetti.style.opacity = 1-0.24*depth;
                    confettiImg.src = 'images/Confetti/Confetti-'+(Math.floor(Math.random() * confettiPieces) + 1)+'.svg';
                    confetti.style.left = Math.random() * width + 'px';
                    confetti.style.animationDelay = Math.random() * 5 + 's';
                    confetti.style.animationDuration = 1.5 + depth * 1.5 + 's';
                    document.getElementById('confetti').appendChild(confetti);                
                }
            },
            // Form Handling

            setNewsletter: function( state ) {

                this.dfNewsletter = state;
                if( state ) {
                    this.dfEmailSave = this.dfEmail;
                    this.dfEmail = '';
                } else {
                    this.dfEmail = this.dfEmailSave;
                }

            },

            removeError: function() {

                return true;

            },

            activateVideo: function() {

                this.dfVideo = Cookiebot.consent.marketing;

            },

            activateRecaptcha: function() {

                this.dfRecaptcha = true;
                window.setTimeout(function() {
                    this.resetRecaptcha();
                }.bind(this),246);

            },

            resetRecaptcha: function() {


                if(!this.captcha) {
                    if(jQuery("#fc").html()) {
                        const element = document.querySelector("#fc");
                        this.captcha = new friendlyChallenge.WidgetInstance(element, {});
                        
                        // Attach event listener right after creating the widget
                        const captchaElement = document.querySelector(".frc-captcha");
                        if(captchaElement) {
                            captchaElement.addEventListener("frc:widget.complete", function(event) {
                                this.friendlyFired = true;
                                console.log("Friendly Captcha fired");
                            }.bind(this));
                        }
                    }
                }
                if(this.captcha) {
                    if(jQuery("#fc").length) {
                       this.captcha.reset();
                    }
                }

            },

            letsWaitForAPI: function() {

                this.waitForApi = true;

            },

            restTheApi: function() {

                this.waitForApi = false;

            },

            toggleNoEmail: function() {
                this.noEmail = !this.noEmail;
            },

            doNewsletter: function() {

            },

            doCode: function() {

                this.submittingCodeForm = true;
                this.submitCodeForm();

            },

            submitCodeForm: function () {

                this.submitError = false;
                this.codeError = '';

                if (this.codeFormValid && !this.waitForApi) {

                    this.letsWaitForAPI();

                    this.payLoad = {
                        email: this.dfEmail.trim(),
                        rc: jQuery('.frc-captcha-solution').val(),
                        code: {
                            code : this.dfCode.trim().toUpperCase(),
                            email: this.dfEmail.trim(),
                            language: this.lang || 'de',
                            newsletterOptIn: this.dfNewsletter
                        }
                    }

                    if(!this.noEmail && this.dfNewsletter) {
                        this.payLoad.code.newsletterOptIn = true;
                    }

                    axios.post("/code",{data : this.payLoad  },{
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }).then( function(r) {                        
                        this.externalIdentifier = r.data.response.externalIdentifier;
                        this.isWinner = r.data.response.winner;
                        this.prize = r.data.response.raffledPrize;
                        this.barcode = r.data.response.barcode;
                        window.setTimeout(function() {
                            this.showResult();
                        }.bind(this), this.apiPause);
                        this.formProcessed = false;
                    }.bind(this)).catch(function(error) {
                        window.setTimeout(function() {
                            if(error.response) {
                                if(error.response.status==419) {
                                    this.csrfexpired = true;
                                } else if(error.response.status==500 || error.response.status==403) {
                                    this.codeError = "code_500";
                                } else if(error.response.data.error) {
                                    this.codeError = error.response.data.error;
                                } else if(error.response.data.errors) {
                                    this.codeError = error.response.data.errors[0];
                                }
                                if(this.codeFailed) {
                                    this.track("Code-Eingabe", "Code Fehlversuch");
                                }
                            }
                            this.resetRecaptcha();
                            if(!this.codeNoRecaptcha) {
                                this.dfCode = '';
                            }
                            this.restTheApi();
                            this.formProcessed = true;
                            if(this.codeError == "recaptcha") {
                                this.scrollTo = "#recaptchaerror"
                            } else {
                                this.scrollTo = "#df_code .notValid"
                            }
                        }.bind(this), this.apiPause);
                    }.bind(this));             


                } else {

                    this.scrollTo = "#df_code .notValid"

                }

            },

            submitWonForm: function() {

                this.submittingForm = true;

                if(!this.orderFormValid) {
                    this.restTheApi();
                    return;
                }

                if (!this.waitForApi) {

                    this.letsWaitForAPI();


                    this.payLoad = {
                        firstName: this.dfFirstname.trim(),
                        lastName: this.dfLastname.trim(),
                        country: this.dfCountry || 'de'
                    }

                    if(this.dfEmail.trim()!="" && !this.noEmail) {
                        this.payLoad.email = this.dfEmail.trim()
                    }
                    
                    axios.post("/won",{id: this.externalIdentifier, data : this.payLoad  },{
                        headers: {
                            'Content-Type': 'application/json'
                        },
                    }).then( function(r) {
                        window.setTimeout(function() {
                            this.sp('thankyou');
                            this.initMafoSlider();
                            this.voucherPdfRef = r.data.response.voucherPdfRef;
                            this.submittingForm = false;
                            this.restTheApi();
                        }.bind(this), this.apiPause);
                    }.bind(this)).catch(function(error) {
                        window.setTimeout(function() {
                            if(error.response) {
                                if(this.codeFailed) {
                                    this.track("Code-Eingabe", "Code Fehlversuch");
                                }
                            }
                            this.resetRecaptcha();
                            this.restTheApi();
                        }.bind(this), this.apiPause);
                    }.bind(this));     
                    
                }

            },

            mafo: function(g, idx, submit) {

                if (this.mafoLock) {
                    return;
                }

                this.mafoLock = true;

                if(idx) {
                    var alpha = String.fromCharCode(96 + idx);
                    this.mafoAnswers[g] = alpha;
                    var allAnswered = true;
                    for (let i = 0; i < this.mafoAnswers.length; i++) {
                        if (this.mafoAnswers[i] == '') {
                            allAnswered = false;
                        }
                    };
                } else {
                    if(!submit) {
                        this.mafoLock = false;
                        return;
                    }
                }

                if(!submit && !allAnswered) {
                    if(window.mafoSlider && typeof window.mafoSlider.slideNext === 'function') {
                        window.mafoSlider.slideNext();
                    }
                    this.mafoLock = false;
                    return;
                }

                var payload = {};
                for (let i = 0; i < this.mafoAnswers.length; i++) {
                    if(this.mafoAnswers[i] != '') {
                        payload['question' + (i+1)] = this.mafoAnswers[i];
                    }
                };

                if(this.externalIdentifier == '') {
                        window.setTimeout(function() {
                            this.mafoLock = false;
                            if(window.mafoSlider && typeof window.mafoSlider.slideTo === 'function') {
                                window.mafoSlider.slideTo(99);
                            }
                            this.mafoDone = true;
                        }.bind(this), 200);
                        return;
            }

                $.post("./mafo", {
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        data: {
                            id: this.externalIdentifier,
                            answers: payload
                        }
                    },
                    function(resp) {

                        window.setTimeout(function() {
                            this.mafoLock = false;
                            window.mafoSlider.slideTo(99);
                            this.mafoDone = true;
                        }.bind(this), 200);

                    }.bind(this)).fail(function(resp) {
                    this.mafoLock = false;
                });

            },

            showResult: function( result ) {

                if(window.mafoSlider) {
                    window.mafoSlider.destroy(true, true);
                    window.mafoSlider = null;    
                }

                if(typeof result !== 'undefined') {
                    this.prize = result;
                }

                this.submittingForm = false;
                if(this.prize == 4) {
                    this.prize = 2;
                    this.sp('thankyou');
                    this.initMafoSlider();
                } else if(this.prize == 3) {
                    this.prize = 1;
                    this.sp('thankyou');
                    this.initMafoSlider();
                } else if(this.prize) {
                    this.sp('won');
                    window.setTimeout(function() {
                        this.newConfetti();
                    }.bind(this), 500);
                } else {
                    this.sp('blank');
                    this.initMafoSlider();
                }
            },

            initMafoSlider: function() {

                if(!window.mafoSlider) {
                        window.setTimeout(function() {
                        window.mafoSlider = new Swiper(".page.show .mafo-container .swiper-container", {
                            speed: 500
                        });
                    }, 500);
                } else {
                    window.mafoSlider.update();
                }

            }
            
        },

        computed: {

            getVoucherLink: function() {
                return "/Center-Parcs-Gutschein?voucher="+this.voucherPdfRef;
            },

            marketingCookies: function() {

                return Cookiebot && Cookiebot.consent.marketing;

            },

            isHome: function() {

                return (this.currentPage=="home");

            },

            isTextPage: function() {

                var textPages = ["danke", "imprint", "kontakt", "tnb", "data"];
                return (textPages.indexOf(this.currentPage) >= 0);
            },

            isThankYou: function() {

                return (this.currentPage == "danke");

            },

            getCurrentPage: function() {

                wfA = (this.waitForApi) ? " waitForApi" : "";

                return 'show-' + this.currentPage + ((this.mounted) ? " show" + wfA : wfA);

            },

            wonShowEmail: function() {

                return this.prize == 'WIN1' || this.prize == "WIN2" || this.prize == "WIN3";

            },

            wonShowPhone: function() {

                return this.prize == 1;

            },

            codeError500: function () {

                return this.submittingCodeForm && this.codeError=="code_500";

            },

            codeMissing: function() {

                return this.submittingCodeForm && this.dfCode == '' && this.codeError=='' && !this.throttleError && !this.limitDay;

            },

            codeFailed: function() {

                return this.submittingCodeForm && (this.codeError.indexOf('ungültig') >= 0 || this.codeError=="code_failed");

            },

            raffleFailed: function() {

                return this.submittingCodeForm && (this.codeError.indexOf('ungültig') >= 0 || this.codeError=="raffle_failed");

            },

            codeBurned: function () {

                return this.submittingCodeForm && (this.codeError.indexOf('bereits') >= 0 || this.codeError=="code_fulfilled" || this.codeError=="code_burned");

            },

            codeNoRecaptcha: function() {
                
                return this.submittingCodeForm && this.codeError.indexOf('recaptcha') >= 0;

            },

            codeTooManyRequests: function() {
                
                return this.submittingCodeForm && this.codeError && this.codeError.indexOf('too_many_request') >= 0;

            },

            overlimit: function() {

                return this.submittingCodeForm && this.codeError == 'overlimit';

            },

            throttle: function() {

                return this.submittingCodeForm && this.codeError == 'throttle';

            },


            genericapi: function() {

                return this.submittingCodeForm && this.codeError == 'code_500';

            },

            countryMissing: function() {

                return this.submittingCodeForm;
            },

            countryValid: function() {
                return (this.dfCountry != '');
            },

            nameValid: function() {  
                return (this.dfFirstname.trim().length >= 1 && this.dfLastname.trim().length >= 1);
            },

            eMailMissing: function () {

                if(this.noEmail) {
                    return false;
                }

                return ((this.submittingCodeForm && this.dfNewsletter) || this.submittingForm) && (!this.dfEmail || this.dfEmail == '');

            },

            eMailNotValid: function () {

                if(this.noEmail) {
                    return false;
                }

                return ((this.submittingCodeForm && !this.noEmail) || this.submittingForm) && !this.eMailValid;

            },

            zipValid: function() {

                return (this.dfZip.length==5 && !isNaN(this.dfZip));
            },

            countryValid: function() {

                const allowedCountries = ['de','at','ch'];
                return (allowedCountries.indexOf(this.dfCountry) >= 0);

            },

            eMailValid: function() {

                if(this.noEmail) {  
                    return true;
                }

                var re = /\S+@\S+\.\S+/;
                let p = this.dfEmail.split(".");
                return re.test(this.dfEmail) & p[p.length - 1].length > 1;

            },

            emailAgainValid: function() {

                var re = /\S+@\S+\.\S+/;
                p = this.haEmailAgain.split(".");
                return re.test(this.dfEmailAgain) & p[p.length - 1].length > 1;

            },

            emailsSame: function() {

                return this.dfEmail.trim().toUpperCase() == this.dfEmailAgain.trim().toUpperCase();

            },

            newsletterCredentialsOkay: function() {

                return this.dfEmail != "" && this.eMailValid && this.emailsSame && this.dfEmailAgain != "" && this.emailAgainValid;

            },

            codeFormValidSingle: function() {

                return (this.dfCode!="");

            },

            codeFormValid: function() {

                if(!this.friendlyFired) {
                    return false;
                }

                if(this.noEmail) {
                    return (this.dfCode!="" && this.dfTerms);
                } else {
                    return (this.dfCode!="" && this.eMailValid && this.dfTerms);
                }


            },

            orderFormValid: function () {

                return this.dfCountry!='' && this.dfVorname!='' && this.dfNachname!='' && this.eMailValid && this.dfTerms;

            },

            possibleFraud: function() {

                return this.submittingForm && !this.codeFormValidSingle;
                
            }

        },

        filters: {

            pretty: function(value) {
                return JSON.stringify(value, null, 2);
            },

            dig2: function(a) {
                return ('0000' + a).substr(-2);
            },

            selectEmpty: function(txt) {
                return (txt == "") ? "Bitte wählen …" : txt;
            },

            uppercase: function(txt) {
                return txt.toUpperCase();
            }

        },

        mounted: function() {

            this.initRest();
            this.restTheApi();

        },

        updated: function() {

        }

    });
    window.dfApp = dfApp;
};

Vue.directive('uppercase', {
    update: function(el) {
        el.value = el.value.toUpperCase()
    },
});
window.dataLayer = window.dataLayer || [];

jQuery(window).bind('load', function() {
    df.init();
});

function initGa() {

    jQuery("#blocker").remove();
    return;

    if (Cookiebot) {
        if(Cookiebot.consent.necessary) {
            jQuery("#blocker").remove();
        }
        if (!gaInit && Cookiebot.consent.marketing) {
            gaInit = true;
            this.dfRecaptcha = true;
        }
        if(Cookiebot.consent.marketing) {
            window.setTimeout( function() {
                var d = new Date();
                var day = d.getDay()+1;
                var mon = d.getMonth()+1;
                var year = d.getFullYear();
                jQuery(".tvspot div").html('<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/9HYNfFoVBFY" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
            },500);
        }
    }

}

function createNewEvent(eventName) {
    var event;
    if (typeof(Event) === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    return event;
}

var df = {

    startpage: 'home',
    resizeTimeOut: 0,
    isLocal: (self.location.href.indexOf('.test') >= 0),
    isScrolling: false,
    scrollMemory: [],

    track: function(category, action, label) {

        label = (label) ? label : "HARIBO x OTTO ";

        if(typeof Cookiebot !== 'undefined') {
            var compliances = Cookiebot.consent;
        } else {
            return;
        }

        var _paq = window._paq = window._paq || [];
        if (compliances?.marketing) {
            if(category == "pageview") {
                var _paq = _paq || [];
                if(action=="init") {
                    action = 'home';
                    _paq.push(["trackPageView"]);
                };
                _paq.push(["setCustomUrl", action]);
                _paq.push(["setDocumentTitle", "Titel: "+action]);
                _paq.push(["trackPageView"]);
                (function() {
                    var u="https://haribo.piwik.pro/";
                    _paq.push(["setTrackerUrl", u+"ppms.php"]);
                    _paq.push(["setSiteId", "0e68e030-bcac-4e28-b651-53ef429a5e56"]);
                    var d=document, g=d.createElement("script"), s=d.getElementsByTagName("script")[0];
                    g.type="text/javascript"; g.async=true; g.defer=true; g.src=u+"ppms.js"; s.parentNode.insertBefore(g,s);
                })();
            } else {
                _paq.push(['trackEvent', category, action]);
            }
        } else {
        }

    },

    // Resize

    resizeTrigger: function() {
    },

    // ScrollTo

    scrollTo: function(i) {

        if (!df.isScrolling && i != "" && i !== undefined) {
            df.isScrolling = true;
            if (isNaN(i)) {
                const element = document.querySelector(i);
                if (element) {
                    const header = document.getElementById('header');
                    const currentScrollMargin = window.getComputedStyle(element).scrollMarginTop;
                    
                    if (header && (!currentScrollMargin || currentScrollMargin === '0px')) {
                        element.style.scrollMarginTop = header.offsetHeight + 'px';
                    }
                    const elementStyle = window.getComputedStyle(element);
                    const marginTop = parseInt(elementStyle.marginTop) || 0;
                    if (marginTop === 0 && header) {
                        element.style.scrollMarginTop = header.offsetHeight + 'px';
                    }
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                    setTimeout(() => {
                        df.isScrolling = false;
                    }, 1000);
                }
            } else {
                jQuery("html, body").animate({ scrollTop: i - jQuery("header").height() },
                    1000,
                    function() {
                        df.isScrolling = false;
                    }
                );
            }
        }

    },

    // Tick

    handleTick: function() {

        if (dfApp.scrollTo != "") {
            df.scrollTo(dfApp.scrollTo);
            dfApp.scrollTo = "";
        }

        this.fixedHeader = (jQuery(window).width() >= 768 && jQuery(window).scrollTop() > 20);

        let winWidth = jQuery(window).width();
        let winHeight = window.innerHeight;
        let headHeight = jQuery("header").outerHeight();
        let visualHeight = jQuery("#visual").outerHeight();

        if (visualHeight > winHeight - headHeight) {
            jQuery("#visual").css("padding-bottom", (winHeight - headHeight) + "px");
        } else if (visualHeight < winHeight - headHeight - 20) {
            jQuery("#visual").css("padding-bottom", "56%");
        }

        jQuery('#homeTop').height(jQuery(window).innerHeight()-jQuery("header").outerHeight());

    },

    /*******************************************/
    /*
    /*  INIT
    */

    formatState: function(state) {
        if (!state.id) {
            return state.text;
        }
        var $state = jQuery('<span class="'+state.id+'">' + state.text + '</span>');
        return $state;
    },

    initSlideshow: function() {

        let currentSlide = 0;
        var slides = [];
        
        function showNextSlide() {
            slides = document.querySelectorAll('.gewinne_swiper > div img');
            if(!slides || slides.length==0) {
                return;
            }
            slides[currentSlide].style.opacity = '0';
            currentSlide = (currentSlide + 1) % slides.length;
            slides[currentSlide].style.opacity = '1';
        }
        
        setInterval(showNextSlide, 3000);

    },

    initSwiper: function() {
        
        new Swiper(".sogehts .swiper-container",{
            autoplay: {
                delay: 3000
            },
            on: {
                slideChangeTransitionEnd: function() {
                    df.track('So geht\'s','So geht\'s '+(this.realIndex+1));
                }
            },
            breakpoints: {
                0: {
                    autoplay: {
                        delay: 3000,
                    },
                    slidesPerView: 1,
                    navigation: {
                        prevEl: '.sogehts-swiper-nav .swiper-prev',
                        nextEl: '.sogehts-swiper-nav .swiper-next',
                    },
                    pagination: {
                        el: '.sogehts-pagination',
                        type: 'bullets',
                        bulletClass: 'bullet',
                        bulletActiveClass: 'bulletff',
                    },
                },
                1024: {
                    autoplay: false,
                    slidesPerView: 3,
                    navigation: {},
                    pagination: {}
                }
            }
        });

    },

    initSelects: function() {

    },

    init: function() {

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': jQuery('meta[name="csrf-token"]').attr('content')
            }
        });

        // Misc

        if(document.getElementById('scrollBlocker')) {
            document.getElementById('scrollBlocker').addEventListener("touchevent", function(e) {
                e.preventDefault();
            });
        }

        window.addEventListener("popstate", function(e) {
            if (e.state) {
                if (e.state.page) {
                    dfApp.sp(e.state.page,false);
                }
            }

        });

        jQuery("#dataLoading").remove();

        initVue();

        window.setTimeout(function() {
            jQuery("body > .wrap").addClass("show");
            jQuery("#app").addClass("show");
            initGa();
        }, 1000);

        df.handleTick();

        window.setInterval(function() {
            df.handleTick();
        }, 333);

        jQuery(window).on("resize",function(){
            df.resizeTrigger();
        });

        jQuery('a[href*="#cookie3"]').on("click",function() {
            //jQuery('.accordion h3:nth-of-type(3)').trigger('click');
        });

        df.resizeTrigger();

        window.setTimeout(function() {
            window.addEventListener('CookiebotOnAccept', function(e) {
            }, false);
        }, 1000);

        jQuery("[href*='#']").click( function(e) {
            var id = '';
            if(jQuery(this).attr('href')) {
                id = jQuery(this).attr('href').split('#')[1];
            }
            if(id && id!="") {
                e.preventDefault();
                dfApp.scrollTo = '#'+id;
            }
        });


    var idx = 1;
    var vwrwd = 0.8*(window.innerWidth/375);
    var vw = 1.2*(window.innerWidth/1600);
    document.documentElement.style.setProperty('--vw-scale', `${vw}`);
    window.addEventListener('resize', () => {
        vwrwd = 0.8*(window.innerWidth/375);
        vw = 1.2*(window.innerWidth/1600);
        document.documentElement.style.setProperty('--vw-scale-rwd', `${vwrwd}`);
        document.documentElement.style.setProperty('--vw-scale', `${vw}`);
    });

 
    },

}

function dateAuto(o) {

    v = o.value;

    if (v.match(/^\d{2}$/)) {
        o.value += '.';
        return;
    }

    if (v.match(/^\d{2}\.\d{2}$/)) {
        o.value += '.';
        return;
    }

}

const dateWeek = function() {

    var now = new Date();
    var onejan = new Date(now.getFullYear(), 0, 1);
    week = Math.ceil((((now - onejan) / 86400000) + onejan.getDay() - 1) / 7);

    return Math.min(34, week);

}

window.mobileAndTabletcheck = function() {
    var check = false;
    (function(a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
};

window.isRetina = function() {
    var mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5),\
            (min--moz-device-pixel-ratio: 1.5),\
            (-o-min-device-pixel-ratio: 3/2),\
            (min-resolution: 1.5dppx)';
    if (window.devicePixelRatio > 1)
        return true;
    if (window.matchMedia && window.matchMedia(mediaQuery).matches)
        return true;
    return false;
}

var validateEmail = function(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

var getCookie = function(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}